import { FeatureToggle, FeatureToggleResponse } from "../domain";
import { Api } from "./api";

export const infoService = {
    getAppConfig: async () => {
        const url = "/info/config";

        const result = await Api.url(url)
            .useSignal("InfoService:getAppConfig")
            .track({ name: "InfoService:getAppConfig" })
            .get<{
                build: string;
                featureToggles: FeatureToggleResponse[];
            }>();
        FeatureToggle.setFeatures(result.featureToggles);
        return result;
    },
};
